import script from "./SideBarItemDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarItemDetail.vue?vue&type=script&setup=true&lang=js"

import "./SideBarItemDetail.vue?vue&type=style&index=0&id=f6d1da04&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6d1da04"]])

export default __exports__